import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';

const UserContext = createContext();

export function UserProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const fetchUser = () => {
        setLoading(true);
        return axios.get("/api/user", { withCredentials: true })  // Add 'return' here
            .then(response => {
                setUser(response.data);
                return response.data;  // Return the user data
            })
            .catch(() => {
                setUser(null);
                return null;
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const logout = () => {
        return axios.post("/api/logout", {}, { withCredentials: true })
            .then(() => {
                setUser(null);
            });
    };

    useEffect(() => {
        fetchUser();
    }, []);

    return (
        <UserContext.Provider value={{ user, setUser, fetchUser, logout, loading }}>
            {children}
        </UserContext.Provider>
    );
}

export function useUser() {
    const context = useContext(UserContext);
    if (!context) {
        throw new Error('useUser must be used within a UserProvider');
    }
    return context;
}